import {ReactNode} from "react";

import SiteHeader from "./SiteHeader";
import ContactMenu from "./ContactMenu";
import Footer from "./Footer";
import {useRouter} from "next/router";

const Layout = ({
	                children,
	                color,
	                headerNotTransparent,
	                showFilterBar,
					hasShadow = false
                }: {
	children: ReactNode;
	color?: string;
	headerNotTransparent?: boolean;
	showFilterBar?: boolean;
	hasShadow?: boolean;
}) => {
	const router = useRouter();
	return (
		<main>
			<SiteHeader
				key={router.pathname}
				showFilterBar={showFilterBar}
				color={color}
				headerNotTransparent={headerNotTransparent}
				hasShadow={hasShadow}
			/>
			{children}
			<ContactMenu/>
			<Footer/>
		</main>
	);
};

export default Layout;
